import React, { useState } from 'react';
import { CalendarCheck2, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../ui/dialog';
import { api } from '../../context/AuthContext';

export const JahreszusatzUmstellen = ({ toast, onDone }) => {
  const [d, setD] = useState(null);
  const [offen, setOffen] = useState(false);
  const [busy, setBusy] = useState(false);
  const pruefen = async () => {
    setOffen(true); setD(null);
    try { setD((await api.post('/kanzlei/rechnungen/jahreszusatz', { anwenden: false })).data); } catch (e) { toast({ title: e?.response?.data?.detail || 'Prüfung fehlgeschlagen', variant: 'destructive' }); setOffen(false); }
  };
  const anwenden = async () => {
    setBusy(true);
    try {
      const r = (await api.post('/kanzlei/rechnungen/jahreszusatz', { anwenden: true })).data;
      toast({ title: `${r.umgestellt.length} Rechnungsnummern umgestellt` }); setOffen(false); onDone();
    } catch (e) { toast({ title: e?.response?.data?.detail || 'Umstellung fehlgeschlagen', variant: 'destructive' }); } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" onClick={pruefen} className="inline-flex items-center gap-1.5 h-9 px-3 text-xs rounded-[10px] border border-gray-200 bg-white text-[#1B3A5C] hover:border-[#b8893d] transition-colors duration-200" data-testid="jahreszusatz-btn">
        <CalendarCheck2 className="w-4 h-4 text-[#b8893d]" />Alte Nummern mit Jahr ergänzen
      </button>
      <Dialog open={offen} onOpenChange={setOffen}>
        <DialogContent className="max-w-xl rounded-2xl" data-testid="jahreszusatz-dialog">
          <DialogTitle className="font-serif text-2xl text-[#1B3A5C]">Jahreszusatz ergänzen</DialogTitle>
          <DialogDescription className="text-xs">Aus 1234 wird 1234/JJ. Das Jahr kommt immer aus dem Rechnungsdatum. Fehlt es, liest das Portal es direkt aus dem Rechnungs-PDF.</DialogDescription>
          {!d ? <span className="inline-flex items-center gap-2 text-xs text-gray-500"><Loader2 className="w-5 h-5 animate-spin text-[#b8893d]" />Rechnungsdaten werden aus den PDFs gelesen …</span> : !d.geplant.length && !d.konflikte.length && !d.ohne_datum.length ? <p className="text-sm text-gray-500 py-4" data-testid="jahreszusatz-leer">Alle Rechnungsnummern haben bereits einen Jahreszusatz.</p> : (
            <>
              <ul className="max-h-[45vh] overflow-y-auto divide-y divide-gray-100 text-sm" data-testid="jahreszusatz-liste">
                {d.geplant.map((p) => (
                  <li key={p.id} className="flex items-center gap-3 py-2" data-testid={`jahreszusatz-${p.id}`}>
                    <span className="font-mono text-gray-500 w-24">{p.alt}</span><span className="text-[#b8893d]">→</span><b className="font-mono text-[#1B3A5C] w-24">{p.neu}</b>
                    <span className="text-[11px] text-gray-500 flex-1">M-{p.mandanten_nr} · Rechnung vom {p.rechnungsdatum.split('-').reverse().join('.')}</span>
                  </li>))}
                {d.konflikte.map((p) => <li key={p.id} className="py-2 text-xs text-rose-700">{p.alt} → {p.neu} übersprungen: Nummer existiert schon</li>)}
                {d.ohne_datum.map((p) => <li key={p.id} className="py-2 text-xs text-amber-800" data-testid={`jahreszusatz-ohne-datum-${p.id}`}>{p.alt} (M-{p.mandanten_nr}) bleibt unverändert: kein Rechnungsdatum im PDF gefunden</li>)}
              </ul>
              <div className="flex justify-end gap-2 pt-2">
                <button type="button" onClick={() => setOffen(false)} className="h-9 px-4 rounded-[10px] border border-gray-200 text-sm text-[#7a8a99]">Abbrechen</button>
                <button type="button" disabled={busy || !d.geplant.length} onClick={anwenden} className="h-9 px-4 rounded-[10px] bg-[#1B3A5C] text-white text-sm disabled:opacity-50" data-testid="jahreszusatz-anwenden">{busy ? 'Wird umgestellt …' : `${d.geplant.length} Nummern umstellen`}</button>
              </div>
            </>)}
        </DialogContent>
      </Dialog>
    </>
  );
};
